import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { AnalyticsService } from '../../../services/analytics.service';
import { Lead } from '../../../models/analytics.model';
import { ParametrosService } from '../../../services/parametros.service';
import { Parametros } from '../../../models/parametros.model';
import { ToastrService } from 'ngx-toastr';
import { ErrorModel } from '../../../models/error.model';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';
import { LeadsStateService } from '../../../services/leadState.service';
import { inject } from '@angular/core';
import { NgxMaskDirective } from 'ngx-mask';
import { nowLocalISOString } from '../../../core/utils/date.util';

@Component({
  selector: 'app-lead-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgxMaskDirective],
  templateUrl: './lead-modal.component.html',
  styleUrls: ['./lead-modal.component.css']
})
export class LeadModalComponent implements OnInit, OnChanges {

  @Input() isOpen = false;
  @Input() leadId: number | null = null;
  @Output() closeModal = new EventEmitter<void>();


  protected leadForm!: FormGroup;
  protected selectedCanal: string = 'Whatsapp';
  protected parametros: Parametros[] = [];
  protected isViewMode = false;

  protected leadsState = inject(LeadsStateService);


  constructor(
    private fb: FormBuilder,
    private parametrosService: ParametrosService,
    private toastr: ToastrService,
    private authService: AuthService,
    private analyticsService: AnalyticsService,
    private router: Router
  ) { 
  }

  ngOnInit(): void {
  
    this.leadForm = this.fb.group({
      nome: ['', Validators.required],
      telefone: ['', Validators.required],
      email: [''],
      canal: [this.selectedCanal, Validators.required],
      descricaoPedido: [''],
      observacao: ['']
    });
   
    this.loadParametros();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen']?.currentValue === true && this.leadForm) {
      if (this.leadId) {
        this.entrarModoVisualizacao(this.leadId);
      } else {
        this.isViewMode = false;
        this.leadForm.enable();
        this.resetForm();
      }
    }
  }

  private entrarModoVisualizacao(id: number): void {
    this.isViewMode = true;
    this.resetForm();
    this.leadForm.disable();

    this.analyticsService.getLeadById(id).subscribe({
      next: (lead) => {
        this.leadForm.patchValue({
          nome: lead.nome,
          telefone: lead.telefone,
          email: lead.email,
          canal: lead.canal,
          descricaoPedido: lead.descricaoPedido,
          observacao: lead.observacao
        });
      },
      error: (error) => {
        const erro: ErrorModel = error?.error;
        this.toastr.error(erro?.message || 'Não foi possível carregar o lead.');
        this.onClose();
      }
    });
  }

  onSubmit() {
    if (this.isViewMode) return;
    if (this.leadForm.valid) {
      const leadData: Lead = {
        id: 0,
        dataRegistro: nowLocalISOString(),
        ...this.leadForm.value
      };

      let id = 0;
      let user = this.authService.getUser();
      if (user === null){
        this.toastr.error("Efetuar login novamente");
        this.router.navigate(['/login']);
        return;
      } else {
      id = user.id;
      }

      this.analyticsService.saveLead(leadData, id).subscribe({
          next: () => {
            this.toastr.success('Lead registrado com sucesso!');
            this.leadsState.refreshTotalLeads();
            this.onClose();
                 
          },
          error: (error) => {
            var erro: ErrorModel = error.error;
            this.toastr.error(erro.message);
          }});
    }
  }

   loadParametros(): void {
    this.parametrosService.getParametrosByCategorias(['CANAL_CONTATO']).subscribe(data => {
      this.parametros = data;
    });
  }



  public resetForm(): void {
      this.leadForm.reset();
      this.leadForm.get('canal')?.setValue(this.selectedCanal);
    }

  public onClose(): void {
    this.isViewMode = false;
    this.leadForm.enable();
    this.resetForm();
    this.closeModal.emit();
  }

  isFieldInvalid(fieldName: string): boolean {
  const control = this.leadForm.get(fieldName);
  return !!(control && control.invalid && (control.touched || control.dirty));
}


}
